import { render, staticRenderFns } from "./MailSetting.vue?vue&type=template&id=aefee624&scoped=true&"
import script from "./MailSetting.vue?vue&type=script&lang=js&"
export * from "./MailSetting.vue?vue&type=script&lang=js&"
import style0 from "./MailSetting.vue?vue&type=style&index=0&id=aefee624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefee624",
  null
  
)

export default component.exports